import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { ITreasureContract ,NFTContarct,DepositContract} from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import NFTABI from "../abis/NFTABI.json";
import DepositAbi from "../abis/DepositAbi.json";

import {
  FaWallet,
  FaHashtag,
  FaBoxOpen,
  FaCopy,
  FaCheck,
  FaFilter
} from "react-icons/fa";
import Nodata from "../assets/img/no-record-found.png";
import Loader from "../components/Loader";

const AllRefferal = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [downlines, setDownlines] = useState([]);

  const [searchValue, setSearchValue] = useState("");
  const [filterLevel, setFilterLevel] = useState(""); 

  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  
  const recordsPerPage = 12;
  

  // INIT WEB3
  useEffect(() => {
    let provider = null;

    if (client?.transport) provider = client.transport;
    else if (window.ethereum) provider = window.ethereum;

    if (!provider) return;

    const w3 = new Web3(provider);
    setWeb3(w3);
  }, [client]);

  // FETCH DATA
  useEffect(() => {
    if (isConnected && address && web3) {
      fetchAllLevelsList(web3);
    }
  }, [isConnected, address, web3]);

  // MAIN FUNCTION
  // const fetchAllLevelsList = async (web3Instance) => {
  //   setLoading(true);
  //   try {
  //     const contract = new web3Instance.eth.Contract(
  //       ITreasureContractABI,
  //       ITreasureContract
  //     );

  //     const totalSlots = 9;
  //     const totalLevels = 18;
  //     const promises = [];

  //     for (let slot = 0; slot < totalSlots; slot++) {
  //       for (let level = 0; level < totalLevels; level++) {
  //         promises.push(
  //           contract.methods
  //             .getFetchLevel(address, slot, level)
              
  //             .call()
  //             .then((members) => ({ slot, level, members }))
  //         );
  //       }
  //     }

  //     const results = await Promise.all(promises);

  //     // Format clean downline list
  //     const formatted = results.flatMap((r) =>
  //       r.members
  //         .filter(
  //           (x) => x !== "0x0000000000000000000000000000000000000000"
  //         )
  //         .map((wallet) => ({
  //           wallet,
  //           slot: r.slot + 1,
  //           level: r.level + 1,
  //         }))
  //     );

  //     setDownlines(formatted);
  //   } catch (err) {
  //     console.error("❌ Error:", err);
  //   }
  //   setLoading(false);
  // };

    const packageToDollar = {
  1: 10,
  2: 20,
  3: 50,
  4: 100,
  5: 200,
  6: 400,
  7: 600,
  8: 1000,
  9: 1500
};

  const fetchAllLevelsList = async (web3Instance) => {
  setLoading(true);
  try {
    const contract = new web3Instance.eth.Contract(
      ITreasureContractABI,
      ITreasureContract
    );

    const totalLevels = 18;  // ⭐ all levels
    const promises = [];

    const slot = 0; // ⭐ slot always 0

    // ---- FETCH LEVELS FOR SLOT 0 ONLY ----
    for (let level = 0; level < totalLevels; level++) {
      promises.push(
        contract.methods
          .getFetchLevel(address, slot, level)
          .call()
          .then((members) => ({ slot, level, members }))
      );
    }

    const results = await Promise.all(promises);

    /* ------------------------------------------------
       STEP 1: Clean downline list
    -------------------------------------------------*/
    const rawList = results.flatMap((r) =>
      r.members
        .filter(
          (x) =>
            x &&
            x !== "0x0000000000000000000000000000000000000000" &&
            x !== ""
        )
        .map((wallet) => ({
          wallet,
          slot: r.slot + 1, // show slot = 1 (even if actual slot = 0)
          level: r.level + 1,
        }))
    );

    /* ------------------------------------------------
       STEP 2: FETCH LAST ACTIVE PACKAGE FOR EACH USER
    -------------------------------------------------*/
    const finalDownlines = [];

    for (let i = 0; i < rawList.length; i++) {
      const user = rawList[i].wallet;

      const packageData = await contract.methods
        .getPackagePurchaseDetails(user)
        .call();

      const purchased = packageData[0];

      let lastActive = 0;
      purchased.forEach((val, index) => {
        if (val) lastActive = index + 1;
      });
       // ⭐ trading fund details
               const Nftcontract = new web3.eth.Contract(DepositAbi, DepositContract);
     
  const cappingData = await Nftcontract.methods
    .getTradingIncomeCapping(user)
    .call();

  const tradeFund = web3Instance.utils.fromWei(
    cappingData.totalDepositFunds,
    "ether"
  );

      finalDownlines.push({
        ...rawList[i],
        dollarValue: packageToDollar[lastActive] || 0 ,
        tradeFundAmount: tradeFund
      });
    }

    setDownlines(finalDownlines);
  } catch (err) {
    console.error("❌ Error:", err);
  }

  setLoading(false);
};


  // FILTER LOGIC
  const filteredList = downlines.filter((item) => {
    const val = searchValue.toLowerCase();
    const w = item.wallet.toLowerCase();

    const passSearch = w.includes(val);

    let passLevel = true;
    if (filterLevel) {
      passLevel = item.level === Number(filterLevel);
    }

    return passSearch && passLevel;
  });

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredList.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  const totalPages = Math.ceil(filteredList.length / recordsPerPage);

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => setCopiedIndex(null), 1200);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFilterLevel("");  // ⭐ Reset level
  };
  if (loading) return <Loader />;

  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> My </span>
          <span className="fw-lighter"> Downline</span>
        </div>

        <button
          className="btn btn-light btn-sm"
          onClick={() => setMobileFilterOpen(true)}
        >
          <FaFilter /> Filter
        </button>
      </h4>

      {/* MAIN CARD */}
      <div className="card paddingfilter">
        <div className="card-body">
          {/* OVERLAY */}
          {mobileFilterOpen && (
            <div
              className="overlay-bg"
              onClick={() => setMobileFilterOpen(false)}
            />
          )}

          {/* FILTER PANEL */}
          <div
            className={`bottom-filter-panel ${
              mobileFilterOpen ? "show" : ""
            }`}
          >
            <div
              className="close-filter"
              onClick={() => setMobileFilterOpen(false)}
            >
              ✕
            </div>

           
            <div className="row">

               {/* LEVEL INPUT ⭐ */}
              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Level</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Level (1–18)"
                  value={filterLevel}
                  min={1}
                  max={18}
                 onChange={(e) => {
                 let val = Number(e.target.value);
             
                 if (val > 18) val = 18;
                 if (val < 1) val = "";
             
                 setFilterLevel(val);
                }}
                />
              </div>

              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Search Wallet</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>

              <div className="col-md-12 col-lg-3 mb-3">
                <label className="visibilty-hidden form-label">btn</label>
                <div className="d-flex gap-2 mobleapplybtn">
                  <button
                    className="btn btn-success"
                    onClick={() => setMobileFilterOpen(false)}
                  >
                    Apply
                  </button>
                  <button className="btn btn-danger" onClick={resetFilters}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* DATA LIST */}
          <div className="row">
            {currentRecords.length > 0 ? (
              currentRecords.map((item, index) => {
                const w = item.wallet || "";
                const masked =
                  w.slice(0, 4) + "****" + w.slice(w.length - 4);

                return (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="ref-card">
                      <div className="ref-card-body">
                        {/* S.No */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaHashtag className="ref-icon" /> S.No.
                          </span>
                          <span className="ref-value">
                            {indexOfFirstRecord + index + 1}
                          </span>
                        </div>

                        {/* WALLET */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaWallet className="ref-icon" /> Wallet
                          </span>

                          <div className="ref-copy-box">
                            <span className="ref-value">{masked}</span>

                            <button
                              className="copy-btn"
                              onClick={() =>
                                handleCopy(item.wallet, index)
                              }
                            >
                              {copiedIndex === index ? (
                                <FaCheck className="copy-icon copied" />
                              ) : (
                                <FaCopy className="copy-icon" />
                              )}
                            </button>
                          </div>
                        </div>

                        {/* LEVEL */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen className="ref-icon" /> Level
                          </span>
                          <span className="ref-value">{item.level}</span>
                        </div>

                         {/* SLOT */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen className="ref-icon" /> Active Package
                          </span>
                          <span className="ref-value">{item.dollarValue}</span>
                        </div>

                        {/* Trading Fund */}
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen className="ref-icon" /> Trading Fund
                          </span>
                          <span className="ref-value">
                            {item.tradeFundAmount} USDT
                          </span>
                        </div>

                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">
                <img src={Nodata} alt="No Data" />
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-div">
              <ul className="pagination mb-0">
                {[...Array(totalPages)].map((_, idx) => (
                  <li
                    key={idx}
                    className={`page-item ${
                      currentPage === idx + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllRefferal;
